<template>
  <div class="optimisation-job-options">
    <div class="optimisation-job-container" v-show="queueOptionsAvailable">
      <StationControlPanelButton data-toggle="dropdown" class="btn-default" sizeClass="wide-lg" iconStyle="fal" icon="fa-cog">Options</StationControlPanelButton> 
      <ul class="dropdown-menu dropdown-menu-left">
        <DropdownMenuItem icon="fa-layer-plus" @click="$emit('createSheetClicked', $event)">New Sheet</DropdownMenuItem>
        <DropdownMenuItem icon="fa-magic" v-if="queueOptionsAvailable" @click="$emit('optimiseQueueClicked', $event)">Optimise Editing Sheets</DropdownMenuItem>
        <DropdownMenuItem icon="fa-trash-alt" v-if="queueOptionsAvailable" @click="$emit('clearQueueClicked', $event)">Remove Editing Sheets</DropdownMenuItem>
      </ul>
    </div>
    <div class="optimisation-job-container" v-show="!queueOptionsAvailable">
      <StationControlPanelButton class="btn-default" sizeClass="wide-lg" iconStyle="fal" icon="fa-plus" @click="$emit('createSheetClicked', $event)">Add Sheet</StationControlPanelButton> 
    </div>
  </div>
</template>

<style scoped>
.optimisation-job-options {
  width: 110px;
  height: 70px;
  display:inline-block;
  cursor: pointer;
  position: relative;
}
.optimisation-job-container {
  position: absolute;
  top: 0px;
  right: 0px;
  bottom: 0;
  left: 10px;
}

</style>

<script>
import StationControlPanelButton from '@/apps/glass-production-station/src/components/buttons/stationControlPanelButton'

export default {
  name: 'QueueOptimiserOptions',
  components: {
    StationControlPanelButton
  },
  props: {
    queueOptionsAvailable: Boolean
  },
  computed: {
    title() {
      return !this.queueOptionsAvailable ? 'Add Sheet' : 'Options'
    },
    icon() {
      return !this.queueOptionsAvailable ? 'fa-plus' : 'fa-cog'
    }
  }
  
}
</script>